<template>
    <div class="c-form-element" :class="{ 'c-form-element--horizontal' : horizontal, 'c-form-element--icon' : icon, 'c-form-element--clean' : clean }">
        <div class="c-form-element__label" v-if="label">
            <label v-html="label"></label>
            <p class="fs-small color-dark-gray" v-if="helptext">{{helptext}}</p>
        </div>
        <div class="c-form-element__container">
            <div class="c-form-element__input">
                <slot></slot>

                <div v-if="password" @click="togglePassword" class="c-form-element__icon c-password-toggle color-medium-gray">
                    <svg v-if="!showPassword" viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M12 13.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m0-5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m.2197 8.4976c-4.306.1-7.115-3.583-8.047-5.002 1.026-1.605 3.61-4.891 7.608-4.993 4.289-.109 7.114 3.583 8.046 5.002-1.025 1.605-3.61 4.891-7.607 4.993m9.648-5.495c-.638-1.112-4.162-6.686-10.138-6.499-5.528.14-8.743 5.01-9.597 6.499a.9986.9986 0 0 0 0 .995c.629 1.097 4.029 6.502 9.892 6.502.082 0 .164-.001.246-.003 5.527-.141 8.743-5.01 9.597-6.499.176-.308.176-.687 0-.995" id="a"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#a"/></svg>

                    <svg v-else viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M21.8676 12.4976c-.415.723-1.391 2.241-2.913 3.629l-1.411-1.411c1.06-.951 1.827-1.997 2.283-2.711-.932-1.419-3.755-5.111-8.046-5.002-.6.015-1.163.109-1.699.251l-1.58-1.58c.972-.384 2.043-.64 3.228-.67 5.975-.187 9.5 5.387 10.138 6.499.176.308.176.687 0 .995Zm-7.95 4.249 1.58 1.58c-.971.384-2.043.64-3.227.67-.082.002-.164.003-.246.003-5.863 0-9.263-5.405-9.892-6.502a.9986.9986 0 0 1 0-.995c.414-.723 1.39-2.241 2.912-3.63l1.411 1.412c-1.06.951-1.826 1.997-2.283 2.711.932 1.419 3.742 5.102 8.047 5.002.6-.015 1.163-.109 1.698-.251Zm-1.918-3.247c-.827 0-1.5-.672-1.5-1.5 0-.025.011-.048.012-.074l1.563 1.563c-.026.001-.049.011-.075.011Zm-7.293-10.207c-.39-.39-1.023-.39-1.414 0-.39.391-.39 1.024 0 1.414l5.631 5.631a3.4541 3.4541 0 0 0-.424 1.662c0 1.93 1.571 3.5 3.5 3.5.59 0 1.155-.147 1.663-.423l5.63 5.63c.196.196.451.293.707.293a.993.993 0 0 0 .707-.293c.391-.39.391-1.023 0-1.414l-16-16Z" fill="currentColor" fill-rule="nonzero"/></svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showPassword: false
        }
    },
    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        icon: {
            type: Boolean,
            default: false
        },
        clean: {
            type: Boolean,
            default: false
        },
        password: {
            type: Boolean,
            default: false
        },
        label: {
            type: String
        },
        helptext: {
            type: String
        }
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
            this.$emit('password', this.showPassword);
        }
    }
}
</script>
